import { render, staticRenderFns } from "./DDoSInfo.vue?vue&type=template&id=023a0492&"
import script from "./DDoSInfo.vue?vue&type=script&lang=js&"
export * from "./DDoSInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports